<template>
  <div :to="to" class="d-flex flex-row align-center disable-link">
    <div class="avatar-wrapper my-2 mr-2">
      <v-tooltip top v-if="avatar">
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on" :size="size">
            <v-img :src="avatar" />
          </v-avatar>
        </template>
        <img :src="avatar" :alt="data.name" style="max-height: 200px; max-width: 200px" />
      </v-tooltip>
      <v-avatar v-else :size="size">
        <v-img src="/default-avatar.png" />
      </v-avatar>
    </div>

    <div :title="data.name" class="staff-name" v-html="data.name"></div>
  </div>
</template>

<script>
export default {
  props: {
    size: Number,
    to: String,
    data: {
      type: [Object],
      default: () => {}
    }
  },
  computed: {
    trueSize() {
      return this.size || 34
    },
    avatar() {
      if (this.data.avatar && this.data.avatar.url) {
        const imgUrl = this.data.avatar.url
        // if (!/^http/.test(imgUrl)) {
        //   return `${process.env.VUE_APP_API_ENDPOINT}${imgUrl}`.replace(/\/+/g,)
        // } else {
        //   return imgUrl
        // }
        return new URL(imgUrl, process.env.VUE_APP_API_ENDPOINT).toString()
        // return new URL(imgUrl, 'http://lms-api.monsterlab.vn').toString()
      }
      return undefined
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
// .staff-name {
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .staff-name {
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: visible;
  }
}
.v-tooltip__content {
  opacity: 1 !important;
}
</style>
